/** macOS uses ⌘ where other systems use Ctrl. */
export const IS_MAC = typeof navigator !== 'undefined' && /Mac|iPhone|iPad/i.test(navigator.platform || navigator.userAgent);

/** How a Ctrl/⌘ shortcut is written for this system, e.g. "Ctrl B" or "⌘B". */
export function shortcutLabel(key: string, mac = IS_MAC): string {
  return mac ? `⌘${key.toUpperCase()}` : `Ctrl ${key.toUpperCase()}`;
}

/** Ctrl+key (or ⌘+key), without Alt or Shift. */
export function isShortcut(event: KeyboardEvent, key: string): boolean {
  return event.key.toLowerCase() === key && (event.ctrlKey || event.metaKey) && !event.altKey && !event.shiftKey;
}

/** Rich-text editors use Ctrl+B for bold: leave the shortcut to them. */
export function isInRichTextEditor(target: EventTarget | null): boolean {
  return target instanceof HTMLElement && target.isContentEditable;
}
